import React, { useEffect, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";
import Icon from "../icon/Icon";

const TooltipComponent = ({ iconClass, icon, id, direction, text, containerClassName, tag, ...props }) => {
  // S'assurer que id est toujours défini
  const tooltipId = id || `tooltip-${Math.random().toString(36).substr(2, 9)}`;
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    // Attendre que le DOM soit monté avant d'afficher le tooltip
    setMounted(true);
  }, []);
  
  // Extraire tag des props pour éviter de le passer à l'élément
  const Tag = tag || props.tag;
  
  return (
    <React.Fragment>
      {Tag ? (
        <Tag 
          className={containerClassName} 
          id={tooltipId}
          {...props} // Passer toutes les autres props (onClick, href, etc.)
        >
          {" "}
          <Icon className={`${iconClass ? iconClass : ""}`} name={icon}></Icon>
        </Tag>
      ) : (
        <Icon 
          className={`${iconClass ? iconClass : ""}`} 
          name={icon} 
          id={tooltipId}
          {...props} // Passer toutes les autres props
        ></Icon>
      )}
      {mounted && tooltipId && text && (
        <UncontrolledTooltip autohide={false} placement={direction || "top"} target={tooltipId}>
          {text}
        </UncontrolledTooltip>
      )}
    </React.Fragment>
  );
};
export default TooltipComponent;
